import request from '@/request'

export async function search(query) {
  query = encodeURIComponent(query)

  const res = await request({
    url: `tools/instatags/search`,
    method: 'get',
    params: { query }
  })

  return res.data
}